import * as React from 'react';

import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import { createReactRenderer } from 'helpers/react-renderer';
import { NuorderOrderingProvider } from 'root/apps/PurchaseOrder/NuorderOrdering/context/Context';
import { NuorderOrdering } from 'root/apps/PurchaseOrder/NuorderOrdering/NuorderOrdering';
import { datadogLogs } from 'root/datadog/datadogLogs';

const devToolsButtonClassName = 'react-query-dev-tools-toggle-button';

interface Props {
  purchaseID?: string | number;
}

export const NuorderOrderingIndex: React.FC<Props> = ({ purchaseID }) => {
  try {
    if (!purchaseID) {
      throw new Error('Invalid purchaseID');
    }
    const parsedPurchaseID = Number(purchaseID);
    if (isNaN(parsedPurchaseID) || parsedPurchaseID <= 0) {
      throw new Error('Invalid purchaseID');
    }

    const hasReactQueryDevtools = () =>
      document.querySelectorAll(`.${devToolsButtonClassName}`).length > 0;

    return (
      <NuorderOrderingProvider purchaseID={parsedPurchaseID}>
        <NuorderOrdering />
        {hasReactQueryDevtools() && (
          <ReactQueryDevtools
            initialIsOpen={false}
            position="bottom-right"
            toggleButtonProps={{ className: devToolsButtonClassName }}
          />
        )}
      </NuorderOrderingProvider>
    );
  } catch (e) {
    datadogLogs.logger.error(
      `Error initializing NuorderOrdering component: ${e.message}`,
      undefined,
      e
    );
  }
  return null;
};

const RenderedComponent = createReactRenderer({
  component: NuorderOrderingIndex,
  selector: '[data-react-root="NuorderOrdering"]',
});

history.onChangeState(
  [
    {
      name: 'purchase.views.purchase',
      form_name: 'view',
      tab: 'nuorder_ordering',
      id: undefined,
    },
  ],
  () => {
    RenderedComponent.mount();
  },
  () => {
    RenderedComponent.unmount();
  }
);
